const particles = [
  { left: '6%', top: '18%', delay: '0s', duration: '8s' },
  { left: '14%', top: '62%', delay: '1.2s', duration: '9.5s' },
  { left: '22%', top: '38%', delay: '2.4s', duration: '7.8s' },
  { left: '31%', top: '74%', delay: '0.8s', duration: '10.2s' },
  { left: '39%', top: '24%', delay: '3.1s', duration: '8.7s' },
  { left: '48%', top: '56%', delay: '1.7s', duration: '9.8s' },
  { left: '57%', top: '16%', delay: '2.1s', duration: '8.3s' },
  { left: '65%', top: '67%', delay: '0.6s', duration: '10.5s' },
  { left: '73%', top: '33%', delay: '3.5s', duration: '7.9s' },
  { left: '82%', top: '58%', delay: '1.5s', duration: '9.1s' },
  { left: '90%', top: '21%', delay: '2.9s', duration: '8.9s' },
  { left: '94%', top: '72%', delay: '0.3s', duration: '10.8s' },
]

export default function GlobalParticles() {
  return (
    <div className="pointer-events-none fixed inset-0 z-[-1] bg-[#020617]" aria-hidden>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(96,165,250,0.14),transparent_42%),radial-gradient(circle_at_80%_30%,rgba(192,132,252,0.12),transparent_40%),radial-gradient(circle_at_50%_80%,rgba(56,189,248,0.1),transparent_45%)]" />
      {particles.map((particle, index) => (
        <span
          key={index}
          className="ds-particle"
          style={{
            left: particle.left,
            top: particle.top,
            animationDelay: particle.delay,
            animationDuration: particle.duration,
          }}
        />
      ))}
    </div>
  )
}
